import React from 'react'
import { FeedItem } from '../../../../Api'
import { FeedCardList } from '../../../../Components/Feed'
import { Head2 } from 'Components/Typography/Text.styles'

type HomeLatestList = {
  contentType: 'article' | 'video'
  feedItems: FeedItem[]
  section: string
}

export const ContentFeed: React.FC<HomeLatestList> = ({
  contentType,
  feedItems,
  section,
}) => {
  const title = contentType === 'article' ? 'Latest News' : 'Latest Vids'

  const filterFeedItems = () => {
    return feedItems.filter((item) => item.type === contentType)
  }

  return (
    <>
      <Head2>
        {title}
      </Head2>
      <FeedCardList feedItems={filterFeedItems()} cardSize="normal" section={section} />
    </>
  )
}
